export default __webpack_public_path__ + "static/media/droneview.bc724b99.mp4";